import React from 'react';
import '../App.css';
import cfl from '../config.json';
import $ from 'jquery';
import config from '.././config.json';
import moment from 'moment';

import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

import {
    Form, Input, Tooltip, Icon, Select, Modal,
    Button, DatePicker, InputNumber, Spin, notification, TimePicker, Row, Col
} from 'antd';

import { Redirect } from 'react-router';
import LoginForm from '../LoginForm.js';

const { RangePicker } = DatePicker;
const FormItem = Form.Item;
const Option = Select.Option;

class AssignESCC extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            login: true,
            classData: [],
            currentCertification: '',
        };
        this.displayList = [];

    }

    /**
     * This code runs after a component is rendered.
     * As a result this is where we retrieve our data from the server.
     */
    componentDidMount() {
        LoginForm.ValidateServerToken(() => { this.setState({ login: false }) });
        this.dropdownlist();
    }

    dropdownlist = () =>
    {
        $.ajax({
            type: 'GET',
            url: `${config.serverUrl}/api/view/getescclasscert`
        })
            .done((data) => {
                this.displayList = [];
                for (let i = 0; i < data.length; i++) {
                    this.displayList.push(
                        <Option key={i}>{data[i].ClassName}</Option>
                    );
                };
                this.setState({
                    classData: data,
                });
            })
            .fail((jqXHR, textStatus, errorThrown) => {
                console.log('failed to get data');
            });


        $.ajax({
            type: 'GET',
            url: `${config.serverUrl}/api/view/getescstudent`
        })
            .done((data) => {
                this.displayListCert = [];
                console.log(data)
                for (let i = 0; i < data.length; i++) {
                    this.displayListCert.push(
                        <Option key={data[i].ID}>{data[i].Name}</Option>
                    );
                }

            })
            .fail((jqXHR, textStatus, errorThrown) => {
                console.log('failed to get data');
            });
    }

    handleChange = (value) => {
        console.log(value); // { key: "lucy", label: "Lucy (101)" }
        this.setState({
            currentCertification: this.state.classData[value].EscCertification,
        });
    }

    handleSubmit = () =>
    {
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                this.certification = {
                    'Id': this.state.classData[values.class].Id,
                    'ClassId': this.state.classData[values.class].ClassId,
                    'EscId': values.certification
                }

                $.ajax({
                    type: 'POST',
                    url: `${config.serverUrl}/api/view/updateescclasscert`,
                    data: this.certification
                })
                    .done((data) => {
                        const modal = Modal.success({
                            title: "Class assignment successful!",
                            content: 'Class has been successfully assigned to ESCC.',
                           
                        });
                        this.props.form.resetFields();
                        this.setState({
                            currentCertification: ''
                        });
                        this.dropdownlist();
                        
                    })
                    .fail((jqXhr) => {
                        console.log('failed to register');
                    });
            }
            });


    }

    
    /**
     * Render function
     */
    render() {
        const { getFieldDecorator } = this.props.form;

        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 6 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 14 },
            },
        };
        const tailFormItemLayout = {
            wrapperCol: {
                xs: {
                    span: 24,
                    offset: 0,
                },
                sm: {
                    span: 14,
                    offset: 6,
                },
            },
        };


        return (
            <div>{
                this.state.login ?
                    <div>
                        <h2>Assign ESCC </h2>
                        <hr />
                        <Form>
                            <FormItem
                                {...formItemLayout}
                                label="Select an ESCC Class"
                            >
                                {getFieldDecorator('class')(
                                    <Select
                                        showSearch
                                        style={{ width: '80%' }}
                                        optionFilterProp="children"
                                        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                        onChange={this.handleChange}
                                    >
                                        {this.displayList}
                                    </Select>)}

                            </FormItem>
                            <FormItem
                                {...formItemLayout}
                                label="Current Certification"
                            >
                                {this.state.currentCertification}
                            </FormItem>
                            <FormItem
                                {...formItemLayout}
                                label="Change Certification"
                            >
                                {getFieldDecorator('certification')(
                                    <Select
                                        showSearch
                                        style={{ width: '60%' }}
                                        optionFilterProp="children"
                                        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                        onChange={this.handleChangeCert}
                                    >
                                        {this.displayListCert}
                                    </Select>)}

                            </FormItem>
                            <Row>
                                <Col span={24}>
                                    <button style={{ marginLeft: 8 }} className="btn btn-default" onClick={() => this.handleSubmit()}>Submit</button>
                                </Col>
                            </Row>
                        </Form>                        
                    </div>
                    : <Redirect to="/login" replace />
            }</div>
        );
    }

}

const WrappedAssignESCC = Form.create()(AssignESCC);

export default WrappedAssignESCC;



// WEBPACK FOOTER //
// ./src/Admin/AssignESCC.js